import { modalRenderer } from '~/modal/modalRendererRegistry';
import { InitialMapPositionModal } from './InitialMapPositionModal';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    InitialMapPosition: undefined;
  }
}

modalRenderer.register('InitialMapPosition', InitialMapPositionModal);
